import type { FC } from 'react'

import { useEffect, useRef, useState } from 'react'
import styled from '@emotion/styled'

interface OTPCountDownProps {
  onCountDownCompleted?: VoidFunction
}

const OTPCountDown: FC<OTPCountDownProps> = ({ onCountDownCompleted }) => {
  // เปลี่ยน type เป็น number | null เพื่อรองรับ window.setInterval/clearInterval ใน browser
  const countDownTimerRef = useRef<number | null>(null)

  const [counter, setCounter] = useState(60)

  useEffect(() => {
    if (counter === 0) {
      onCountDownCompleted?.()

      return
    }

  // ใช้ window.setInterval เพื่อให้ได้ type เป็น number (แก้ปัญหา TS2769)
  countDownTimerRef.current = window.setInterval(() => setCounter(counter - 1), 1000)

    // ใช้ window.clearInterval และตรวจสอบ null ก่อน (แก้ปัญหา TS2769)
    return () => {
      if (countDownTimerRef.current !== null) {
        window.clearInterval(countDownTimerRef.current)
      }
    }
  }, [counter, onCountDownCompleted])

  return <OTPCountDownTimer>00:{renderCounterToString()}</OTPCountDownTimer>

  function renderCounterToString() {
    if (counter > 9) {
      return counter
    }

    return `0${counter}`
  }
}

export default OTPCountDown

const OTPCountDownTimer = styled.span`
  color: #999;
  font-size: 14px;
  font-weight: 500;
  
`
